/** When your routing table is too long, you can split it into small modules**/

import InspectDrawHome from  '@/components/inspectDrawHome'

/*
import taskCertification from '@/views/inspectDraw/business/task/certification'
import taskCharge from '@/views/inspectDraw/business/task/charge'
import taskCheck from '@/views/inspectDraw/business/task/check'
import taskComputed from '@/views/inspectDraw/business/task/computed'
import taskExpert from '@/views/inspectDraw/business/task/expert'
import taskExamine from '@/views/inspectDraw/business/task/examine'
import taskMaintain from '@/views/inspectDraw/business/task/maintain'
import taskNewTask from '@/views/inspectDraw/business/task/newTask'
import taskQuery from '@/views/inspectDraw/business/task/query'
import taskReply from '@/views/inspectDraw/business/task/reply'
import taskPaused from '@/views/inspectDraw/business/task/paused'
import taskRecord from '@/views/inspectDraw/business/task/record'
import taskRecheck from '@/views/inspectDraw/business/task/recheck'
import chargeStatistics from '@/views/inspectDraw/business/statistics/charge'
import taskStatistics from '@/views/inspectDraw/business/statistics/task'
import queryStatistics from '@/views/inspectDraw/business/statistics/query'
import reportExamine from '@/views/inspectDraw/business/reportExamine/list'
import editTask from '@/views/inspectDraw/business/reportExamine/editTask'
import inspectDrawDetails from '@/views/inspectDraw/business/reportExamine/details'
import taskQueryProcedure from '@/views/inspectDraw/business/reportExamine/procedure'


import taskQueryList from '@/views/inspectDraw/business/taskQuery/list'
import infoConstruction from '@/views/inspectDraw/business/information/construction'
import infoDesign from '@/views/inspectDraw/business/information/design'
import Designset from '@/views/inspectDraw/business/information/design_set'
import infoItemtype from '@/views/inspectDraw/business/information/itemtype'
import infoCharge from '@/views/inspectDraw/business/information/charge'
import infoPolicy from '@/views/inspectDraw/business/information/policy'
import infoStrong from '@/views/inspectDraw/business/information/strong'
import infoExpert from '@/views/inspectDraw/business/information/expert'
import expertDrawing from '@/views/inspectDraw/business/expert/drawing'
import expertOpinion from '@/views/inspectDraw/business/expert/opinion'
import expertQuery from '@/views/inspectDraw/business/expert/query'
import expertExamine from '@/views/inspectDraw/business/expert/examine'
import expertSystem from '@/views/inspectDraw/business/expert/system'
import expertDrawTree from '@/views/inspectDraw/business/expert/drawTree'
import drawProcedure from '@/views/inspectDraw/business/taskQuery/procedure'
import drawTaskContract from '@/views/inspectDraw/business/taskContract/list'
import drawConfig from '@/views/inspectDraw/business/configuration/config'
import drawProfessional from '@/views/inspectDraw/business/configuration/professional'
import drawNotice from '@/views/inspectDraw/business/configuration/notice'
import drawDesignAudit from '@/views/inspectDraw/business/configuration/designAudit'
import drawDesignList from '@/views/inspectDraw/business/configuration/designList'
import taskStatisticsList from '@/views/inspectDraw/business/taskStatistics/list'

import drawContractTemplate from '@/views/inspectDraw/business/contractTemplate/list'
import staffManager from '@/views/inspectDraw/business/staffManager/list'
import expertManager from '@/views/inspectDraw/business/expertManager/list'
import customerInfo from '@/views/inspectDraw/business/customer/info'
import customerEdit from '@/views/inspectDraw/business/customer/edit'
import customerIcon from '@/views/inspectDraw/business/customer/customer_icon'
import userManager from '@/views/inspectDraw/business/userManager/list'
import TaskQueryPro from '@/views/inspectDraw/business/taskQuery/procedure'
import taskDetail from '@/views/common/task/details'

import administration from '@/views/inspectDraw/maintain/administration/list'
import customerInfoList from '@/views/inspectDraw/maintain/customerinfo/list'
import regionInfo from '@/views/inspectDraw/maintain/regioninfo/list'*/
const draw = {
  path: '/inspectDrawHome',
  name: 'inspectDrawHome',
  redirect:{path:'/inspectDrawHome/HOME/draw'},
  meta: {draw: true},
  component: InspectDrawHome,
  children: [
    {
      path: 'HOME/:type',
      component: () => import('@/views/inspectDraw/business/configuration/home'),
      name: 'DrawHOME',
    },
    {
      path: '/inspectDraw/taskCertification',
      component: () => import('@/views/inspectDraw/business/task/certification'),
      name: 'taskCertification',
      keepAlive:true,
      keepCount:true
    },
    {
      path: '/inspectDraw/taskCharge',
      component: () => import('@/views/inspectDraw/business/task/charge'),
      name: 'taskCharge',
    },
    {
      path: '/inspectDraw/taskCheck',
      component: () => import('@/views/inspectDraw/business/task/check'),
      name: 'taskCheck',
    },
    {
      path: '/inspectDraw/taskComputed',
      component: () => import('@/views/inspectDraw/business/task/computed'),
      name: 'taskComputed',
    },
    {
      path: '/inspectDraw/taskExamine',
      component: () => import('@/views/inspectDraw/business/task/examine'),
      name: 'taskExamine',
    },
    {
      path: '/inspectDraw/taskMaintain',
      component: () => import('@/views/inspectDraw/business/task/maintain'),
      name: 'taskMaintain',
      meta:{
        keepAlive:true,
        keepCount:true
      }
    },
    {
      path: '/inspectDraw/taskNewTask',
      component: () => import('@/views/inspectDraw/business/task/newTask'),
      name: 'taskNewTask',
      meta:{
        keepAlive:true,
        keepCount:true
      }
    },
    {
      path: '/inspectDraw/taskQuery',
      component: () => import('@/views/inspectDraw/business/task/query'),
      name: 'taskQuery',
      meta:{
        keepAlive:true,
        keepCount:true
      }
    },
    {
      path: '/inspectDraw/taskPaused',
      component: () => import('@/views/inspectDraw/business/task/paused'),
      name: 'taskPaused',
    },
    {
      path: '/inspectDraw/taskRecheck',
      component: () => import('@/views/inspectDraw/business/task/recheck'),
      name: 'taskRecheck',
    },
    {
      path: '/inspectDraw/taskStatistics',
      component: () => import('@/views/inspectDraw/business/statistics/task'),
      name: 'taskStatistics',
    },
    {
      path: '/inspectDraw/queryStatistics',
      component: () => import('@/views/inspectDraw/business/statistics/query'),
      name: 'queryStatistics',
    },
    {
      path: '/inspectDraw/chargeStatistics',
      component: () => import('@/views/inspectDraw/business/statistics/charge'),
      name: 'chargeStatistics',
    },
    {
      path: '/inspectDraw/greenBa',
      component: () => import('@/views/inspectDraw/business/reportExamine/greenBul'),
      name: 'greenBa',
      meta: {title : '绿建审查汇总'}
    },
    {
      path: '/inspectDraw/reportExamine',
      component: () => import('@/views/inspectDraw/business/reportExamine/list'),
      name: 'reportExamine',
      meta:{
        keepAlive:true,
        keepCount:true
      }
    },
    {
      path: '/inspectDraw/TaskQueryPro',
      component: () => import('@/views/inspectDraw/business/taskQuery/procedure'),
      name: 'TaskQueryPro',
    },
    {
      path: '/inspectDraw/editTask',
      component: () => import('@/views/inspectDraw/business/reportExamine/editTask'),
      name: 'editTask',
    },
    {
      path: '/inspectDraw/detail',
      component: () => import('@/views/inspectDraw/business/reportExamine/details1'),
      name: 'inspectDrawDetails',
    },
    {
      path: '/inspectDraw/pushDetail',  // 数据推送填写信息原先版本页面
      component: () => import('@/views/inspectDraw/business/reportExamine/writePushDetail'),
      name: 'writePushDetail',
    },
    {
      path: '/inspectDraw/wripushDetail',  // 数据推送填写信息更改版本页面
      component: () => import('@/views/inspectDraw/business/reportExamine/wripushdetail'),
      name: 'wripushdetail',
    },
    
    {
      path: '/inspectDraw/viPushDetail', // 查看数据推送填写信息原先版本页面
      component: () => import('@/views/inspectDraw/business/reportExamine/viWritePushDetail'),
      name: 'viWritePushDetail',
    },
    {
      path: '/inspectDraw/viewPushDetail', // 查看数据推送填写信息更改版本页面
      component: () => import('@/views/inspectDraw/business/reportExamine/viewPushDetail'),
      name: 'viewPushDetail',
    },
    {
      path: '/inspectDraw/infomation',
      component: () => import('@/views/inspectDraw/business/reportExamine/infomation'),
      name: 'inspectDrawInfomation',
    },
    {
      path: '/inspectDraw/procedure',
      component: () => import('@/views/inspectDraw/business/reportExamine/procedure'),
      name: 'inspectDrawProcedure',
    },
    {
      path: '/common/task/detail',
      component: () => import('@/views/inspectDraw/business/reportExamine/details1'),
      name: 'taskDetail_draw',
    },
    {
      path: '/inspectDraw/taskRevert',
      component: () => import('@/views/inspectDraw/business/taskQuery/revert'),
      name: 'taskQueryRervert',
    },{
      path: '/inspectDraw/taskQueryList',
      component: () => import('@/views/inspectDraw/business/taskQuery/list'),
      name: 'taskQueryList',
      meta:{
        keepAlive:true,
        keepCount:true
      }
    },{
      path: '/inspectDraw/taskRecord',
      component: () => import('@/views/inspectDraw/business/task/record'),
      name: 'taskRecord',
    },{
      path: '/inspectDraw/procedureA',
      component: () => import('@/views/inspectDraw/business/taskQuery/procedure'),
      name: 'drawProcedure',
    },{
      path: '/inspectDraw/drawTaskContract',
      component: () => import('@/views/inspectDraw/business/taskContract/list'),
      name: 'drawTaskContract',
    },{
      path: '/inspectDraw/taskExpert',
      component: () => import('@/views/inspectDraw/business/task/expert'),
      name: 'taskExpert',
    }/*,{
      path: '/inspectDraw/infoConstruction',
      component: () => import('@/views/inspectDraw/business/information/construction'),
      name: 'infoConstruction',
    },{
      path: '/inspectDraw/infoDesign',
      component: () => import('@/views/inspectDraw/business/information/design'),
      name: 'infoDesign',
    },{
      path: '/inspectDraw/Designset',
      component: () => import('@/views/inspectDraw/business/information/design_set'),
      name: 'Designset',
    },{
      path: '/inspectDraw/infoItemtype',
      component: () => import('@/views/inspectDraw/business/information/itemtype'),
      name: 'infoItemtype',
    },{
      path: '/inspectDraw/infoPolicy',
      component: () => import('@/views/inspectDraw/business/information/policy'),
      name: 'infoPolicy',
    },{
      path: '/inspectDraw/infoStrong',
      component: () => import('@/views/inspectDraw/business/information/strong'),
      name: 'infoStrong',
    }*/,{
      path: '/inspectDraw/infoCharge',
      component: () => import('@/views/inspectDraw/business/information/charge'),     //收费方式
      name: 'infoCharge',
    },{
      path: '/inspectDraw/infoExpert',
      component: () => import('@/views/inspectDraw/business/information/expert'),
      name: 'infoExpert',
    },
    {
      path: '/inspectDraw/drawContractTemplate',
      component: () => import('@/views/inspectDraw/business/contractTemplate/list'),
      name: 'drawContractTemplate',
    },{
      path: '/inspectDraw/expertDrawing',
      component: () => import('@/views/inspectDraw/business/expert/drawing'),
      name: 'expertDrawing',
    },{
      path: '/inspectDraw/expertOpinion',
      component: () => import('@/views/inspectDraw/business/expert/opinion'),
      name: 'expertOpinion',
    },{
      path: '/inspectDraw/expertQuery',
      component: () => import('@/views/inspectDraw/business/expert/query'),
      name: 'expertQuery',
    },{
      path: '/inspectDraw/expertExamine',
      component: () => import('@/views/inspectDraw/business/expert/examine'),
      name: 'expertExamine',
    },{
       // inspectDraw/expertSystem
      path: '/inspectDraw/expertSystem',
      component: () => import('@/views/inspectDraw/business/expert/system'),
      name: 'expertSystem',
    },{
      path: '/inspectDraw/staffManager',
      component: () => import('@/views/inspectDraw/business/staffManager/list'),
      name: 'staffManager',
    },{
      path: '/inspectDraw/expertManager',
      component: () => import('@/views/inspectDraw/business/expertManager/list'),
      name: 'expertManager',
    },
 {
      path: '/inspectDraw/customerInfo',
      component: () => import('@/views/inspectDraw/business/customer/info'),
      name: 'customerInfo',
    },{
      path: '/inspectDraw/customerIcon',
      component: () => import('@/views/inspectDraw/business/customer/customer_icon'),
      name: 'customerIcon',
    },{
      path: '/inspectDraw/userManager',
      component: () => import('@/views/inspectDraw/business/userManager/list'),
      name: 'userManager',
    },
    // {
    //   path: '/inspectDraw/drawConfig',
    //   component: () => import('@/views/inspectDraw/business/configuration/config'),
    //   name: 'drawConfig',
    // },
    /*
    {
      path: '/inspectDraw/drawProfessional',
      component: () => import('@/views/inspectDraw/business/configuration/professional'),
      name: 'drawProfessional',
    },{
      path: '/inspectDraw/drawNotice',
      component: () => import('@/views/inspectDraw/business/configuration/notice'),
      name: 'drawNotice',
    },{
      path: '/inspectDraw/drawDesignAudit',
      component: () => import('@/views/inspectDraw/business/configuration/designAudit'),
      name: 'drawDesignAudit',
    },{
      path: '/inspectDraw/drawDesignList',
      component: () => import('@/views/inspectDraw/business/configuration/designList'),
      name: 'drawDesignList',
    }*/,{
      path: '/inspectDraw/taskReply',
      component: () => import('@/views/inspectDraw/business/task/reply'),
      name: 'taskReply',
      meta:{
        keepAlive:true,
        keepCount:true
      }
    },{
      path: '/inspectDraw/taskStatisticsList',
      component: () => import('@/views/inspectDraw/business/taskStatistics/list'),
      name: 'taskStatisticsList',
    },{
      path: '/inspectDraw/expertDrawTree',
      component: () => import('@/views/inspectDraw/business/expert/drawTree'),
      name: 'expertDrawTree',
    },{
      path: '/inspectDraw/administration',
      component: () => import('@/views/inspectDraw/maintain/administration/list'),
      name: 'administration',
    },{
      path: '/inspectDraw/customerInfoList',
      component: () => import('@/views/inspectDraw/maintain/customerinfo/list'),
      name: 'customerInfoList',
    },{
      path: '/inspectDraw/regionInfo',
      component: () => import('@/views/inspectDraw/maintain/regioninfo/list'),
      name: 'regionInfo',
    },{
      path: '/inspectDraw/report',
      component: () => import('@/views/inspectDraw/maintain/report/list'),
      name: 'report',
    },{
      path: '/inspectDraw/reportEdit',
      component: () => import('@/views/inspectDraw/maintain/report/edit'),
      name: 'reportEdit',
    },{
      path: '/inspectDraw/reportInfo',
      component: () => import('@/views/inspectDraw/maintain/report/info'),
      name: 'reportInfo',
    },{
      path: '/inspectDraw/reportView',
      component: () => import('@/views/inspectDraw/maintain/report/view'),
      name: 'reportView',
    },{
      path: '/inspectDraw/userMaintenance',
      component: () => import('@/views/inspectDraw/maintain/userMaintenance/list'),
      name: 'userMaintenance',
    },{
      path: '/inspectDraw/taskMaintenance',
      component: () => import('@/views/inspectDraw/maintain/task/list'),
      name: 'taskMaintenance',
      mate:{keepAlive:true,keepCount:true},
    },{
      path: '/inspectDraw/projectQueryProduce',
      component: () => import('@/views/inspectDraw/maintain/task/queryProduce'),
      name: 'projectQueryProduce',
    },{
      path: '/inspectDraw/select',
      component: () => import('@/views/inspectDraw/business/taskChange/select'),
      name: 'select',
    },{
      path: '/inspectDraw/forms',
      component: () => import('@/views/inspectDraw/business/expert/report_forms'),
      name: 'reportForms',
    },{
      path: '/inspectDraw/drawinMessage',
      component: () => import('@/views/inspectDraw/business/task/inMessage'),
      name: 'drawinMessage',
    },{
      path: '/inspectDraw/comment',
      component: () => import('@/views/inspectDraw/maintain/comment/list'),
      name: 'comment',
    },{
      path: '/inspectDraw/configList',
      component: () => import('@/views/inspectDraw/maintain/config/list'),
      name: 'configList',
      mate: { keepAlive: true, keepCount: true },
    },{
      path: '/inspectDraw/config',
      component: () => import('@/views/inspectDraw/maintain/config/config'),
      name: 'config',
    },{
      path: '/inspectDraw/statement/project',
      component: () => import('@/views/inspectDraw/maintain/statement/project'),
      name: 'statementProject',
    },{
      path: '/inspectDraw/common/signature',
      component: () => import('@/views/common/signature/list'),
      name: 'signature',
    },{
      path: '/inspectDraw/signature',
      component: ()=>import('@/views/common/task/signature'),
      name: 'drawSignature',
    },{
      path: '/inspectDraw/drawManage',
      component: ()=>import('@/views/inspectDraw/business/task/drawManage'),
      name: 'drawManage',
    },{
      path: '/inspectDraw/drawManage/detail',
      component: ()=>import('@/views/inspectDraw/business/task/manageDetail'),
      name: 'manageDetail',
    },{
      path: '/inspectDraw/drawMessage',
      component: ()=>import('@/views/inspectDraw/maintain/drawMessage/list'),
      name: 'drawMessage',
    },{
      path: '/inspectDraw/spotCheck',
      component: ()=>import('@/views/inspectDraw/maintain/drawMessage/spotCheck'),
      name: 'drawSpotcheck',
    },{
      path: '/inspectDraw/exportStatus',
      component: ()=>import('@/views/inspectDraw/business/task/drawStatus'),
      name: 'drawExportStatus',
    },{
      path: '/inspectDraw/sgtPush',
      component: ()=>import('@/views/inspectDraw/business/task/sgtPush'),
      name: 'sgtPushStatus',
    },{
      path: '/inspectDraw/expertDownloadList',
      component: () => import('@/views/inspectDraw/business/expert/download_list'),
      name: 'inspectDrawDownloadList',
    },{
      path: '/inspectDraw/projectChange/:type',
      component: () => import('@/views/constructionUnit/projectChange/list'),
      name: 'porjectAffirm',
    },{
      path: '/inspectDraw/task/drawing',
      component: () => import('@/views/inspectDraw/business/task/drawing'),
      name: 'drawing',
    },{
      path: '/inspectDraw/formConfig/list',
      component: () => import('@/views/inspectDraw/maintain/formConfig/list'),
      name: 'formConfigList',
      mate: { keepAlive: true, keepCount: true },
    },{
      path: '/inspectDraw/formConfig/edit',
      component: () => import('@/views/inspectDraw/maintain/formConfig/edit'),
      name: 'formConfigEdit',
    },
    {
      path: '/inspectDraw/restPassword',
      component: () => import('@/views/inspectSupervise/maintain/config/rest_password'),
      name: 'inspectSuperviserestPassword',
    },{
      path: '/inspectDraw/drawingSignature',
      component: () => import('@/views/inspectDraw/business/task/drawingSignature'),
      name: 'drawingSignature',
    },{
      path: '/inspectDraw/tablearea',
      component: () => import('@/views/common/task/tablearea'),
      name: 'inspectTablearea',
    },{
      path: '/inspectDraw/draw_compact',
      component: () => import('@/views/common/task/draw_compact'),
      name: 'inspectDraw_draw_compact',
      meta: {title : '图审合同管理',},
    },
    {
      path: '/inspectDraw/supervise_compact',
      component: () => import('@/views/common/task/supervise_compact'),
      name: 'inspectDraw_supervise_compact',
      meta: {title : '图审合同管理',},
    },{
      path: '/inspectDraw/reportForms',
      component: () => import('@/views/inspectDraw/business/reportForms/reportForms'),
      name: 'reportForms',
      meta: {title : '报表统计',},
    },
    {
      path: '/inspectDraw/project_startstop',
      component: () => import('@/views/inspectDraw/business/task/project_startstop'),
      name: 'project_startstop',
    },
  ]
};

export default draw



// WEBPACK FOOTER //
// ./src/router/draw/index.js